import module from 'recursoshumanos/module.js'
import template from './template.html'
import {orderBy} from 'lodash'
import moment from 'moment'

const opciones = [
  {id: 1, descripcion: 'Mensual'},
  {id: 2, descripcion: 'Bimestral'},
]

const indicadores = [
  {id: 1, descripcion: 'Errores', cantidad: 0},
  {id: 2, descripcion: 'Advertencias', cantidad: 0},
  {id: 3, descripcion: 'Correctos', cantidad: 0},
]

const sanitizar = (value) => value.replace(/[^a-zA-Z ]/g, '')

export class RecursoshumanosPagosSuaHistorialComponent {
  idEmpresa
  primaRiesgo
  fecha
  periodicidad
  indicadores = indicadores
  buscando = false
  data = {
    idEmpresa: null,
    fecha: null,
    primaRiesgo: null,
  }
  opciones = opciones
  resultados
  filtro = ''

  constructor (RecursoshumanosOperadorasService, RecursoshumanosRegistropatronalService, recursoshumanosPagosSuaHistorialService, $location) {
    this.RecursoshumanosOperadorasService = RecursoshumanosOperadorasService
    this.RecursoshumanosRegistropatronalService = RecursoshumanosRegistropatronalService
    this.recursoshumanosPagosSuaHistorialService = recursoshumanosPagosSuaHistorialService
    this.$location = $location
  }

  $onInit () {
    this.data.idEmpresa = this.idEmpresa
    this.data.primaRiesgo = this.primaRiesgo
    this.data.fecha = this.fecha
    this.data.periodicidad = this.periodicidad

    this.promise = this.RecursoshumanosOperadorasService.get()
      .then(({data}) => {
        this.operadoras = orderBy(data, ['nombre'])
        if (this.data.idEmpresa) {
          this.registro(false)
        }
      })
  }

  buscar () {
    this.$location.search({
      id_empresa: this.data.idEmpresa,
      fecha: moment(this.data.fecha).format('YYYY-MM-DD'),
      prima_riesgo: this.data.primaRiesgo,
      periodicidad: this.data.periodicidad,
    })

    this.buscando = true

    this.periodicidad = this.data.periodicidad
    this.resultados = []

    this.recursoshumanosPagosSuaHistorialService.get(this.data.idEmpresa, this.data.primaRiesgo, this.data.fecha.getFullYear(), this.data.fecha.getMonth() + 1, this.data.periodicidad)
      .then(({data}) => (this.comprobar(data)))
      .then(() => (this.idIndicador = this.colaboradores[0].indicador))
      .then(() => (this.filtrar()))
      .finally(() => (this.buscando = false))
  }

  comprobar (data) {
    let resultados = data
    try {
      resultados.forEach(item => {
        item.dias = 0
        item.salario = 0
        item.subtotal = 0
        item.total = 0
        item.infonavit = 0
        item.indicador = item.emision.length ? 3 : 1
        item.emision.forEach(emision => {
          item.dias += +emision.dias || null
          item.salario = +emision.salario || item.salario
          item.subtotal += +emision.subtotal || null
          item.total += +emision.total || null
          item.infonavit += +emision.subtotalInfonavit || null
        })
        let sua = item.sua ? item.sua[0] : null
        if (sua) {
          sua.nombreCompleto = `${item.sua[0].apellido_paterno} ${item.sua[0].apellido_materno} ${item.sua[0].nombre}`
          if (+(+sua.subtotal).toFixed(2) !== +(item.subtotal.toFixed(2)) && this.data.periodicidad === 2) {
            item.indicador = 2
            item.subtotal = false
          }
          if (+sua.salario !== item.salario) {
            item.indicador = 2
            item.salario = false
          }
          if (sanitizar(sua.nombreCompleto.trim()) !== sanitizar(item.nombre.trim())) {
            item.indicador = 2
            item.nombre = false
          }
          if (this.data.periodicidad === 1 && +sua.dias !== item.dias) {
            item.indicador = 2
            item.dias = false
          }
          if (+sua.diasBimestre !== item.dias && this.data.periodicidad === 2) {
            item.indicador = 2
            item.dias = false
          }

          if (sua.total !== item.total && this.data.periodicidad === 1) {
            item.indicador = 2
            item.total = false
          }
          if (sua.infonavit !== item.infonavit && this.data.periodicidad === 2) {
            item.indicador = 2
            item.infonavit = false
          }
          if(this.data.periodicidad === 2 && item.infonavit && item.dias && item.subtotal) {
            item.indicador = 3
          }
        } else {
          item.indicador = 1
        }
        item.busqueda = `${item.nombre}|${item.nss}`
      })
    }catch (e) {
      console.error(e)
    }
    this.colaboradores = orderBy(resultados, ['indicador'])
  }


  filtrar () {
    let filtro = this.filtro.toUpperCase()
    this.resultados = this.colaboradores.filter(item => item.busqueda.contains(filtro) && item.indicador === this.idIndicador)
  }

  registro (refresco) {
    if (!refresco) {
      this.data.registro_patronal_id = null
    }

    this.registros = []
    this.RecursoshumanosRegistropatronalService.get(this.data.idEmpresa)
      .then(({data}) => (this.registros = data))
      .catch((error) => (console.error(error)))
  }
}

module.component('recursoshumanosPagosSuaHistorial', {
  controller: RecursoshumanosPagosSuaHistorialComponent,
  template,
  bindings: {
    idEmpresa: '<',
    primaRiesgo: '<',
    fecha: '<',
    periodicidad: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/pagossua/historial/component.js